import { immerable } from 'immer';

interface ISemanticRuleItemEntity {
	id: number;
	label: string;
	description: string;
}

const entityDefaults: ISemanticRuleItemEntity = {
	id: -1,
	label: '',
	description: '',
};

export class SemanticRuleItemEntity implements ISemanticRuleItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public description = entityDefaults.description;
	public label = entityDefaults.label;

	public static build(
		params: Partial<ISemanticRuleItemEntity> = {}
	): SemanticRuleItemEntity {
		const entity = new SemanticRuleItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.description = params.description ?? entityDefaults.description;
		entity.label = params.label ?? entityDefaults.label;
		return entity;
	}
}
